var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconClock = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14.95,
  height: 14.949,
  viewBox: "0 0 14.95 14.949",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_275",
  "data-name": "Group 275",
  transform: "translate(-965.592 -229.6)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 7.025,
  cy: 7.025,
  r: 7.025,
  transform: "translate(966.042 230.05)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_273",
  "data-name": "Group 273",
  transform: "translate(973.067 233.562)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M.029,4.385,0,0",
  fill: "none",
  stroke: "#545454",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_81",
  "data-name": "Line 81",
  x2: 3.517,
  transform: "translate(0 4.113)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_82",
  "data-name": "Line 82",
  y2: 1.5,
  transform: "translate(973.067 230.05)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_83",
  "data-name": "Line 83",
  y2: 1.5,
  transform: "translate(973.067 242.55)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_84",
  "data-name": "Line 84",
  x1: 1.542,
  transform: "translate(966.042 237.074)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_85",
  "data-name": "Line 85",
  x1: 1.544,
  transform: "translate(978.584 237.074)",
  fill: "none",
  stroke: "#545454",
  strokeMiterlimit: 10,
  strokeWidth: 0.9
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_clock.8b198305.svg";
export { ForwardRef as ReactComponent };